import styles from './Content.module.css';

export const Content = ({
    title,
    icon,
    senderLogo,
    receiverLogo,
    ctaText,
    ctaOnClick
}: {
    title: React.ReactNode;
    icon: React.ReactNode;
    senderLogo: string;
    receiverLogo: string;
    ctaText?: React.ReactNode;
    ctaOnClick?: () => void;
}) => (
    <>
        <div className={styles.title} data-testid="payment-processing-title">
            {title}
        </div>

        <div className={styles.processingWrapper}>
            <div id="senderLogoContainer">
                <img
                    src={senderLogo}
                    alt="Sender Logo"
                    className={styles.iwocaLogo}
                ></img>
            </div>

            {icon}

            <div id="receiverLogoContainer">
                <img
                    src={receiverLogo}
                    alt="Receiver Logo"
                    className={styles.iwocaLogo}
                ></img>
            </div>
        </div>

        {ctaText && ctaOnClick ? (
            <div className={styles.cta} onClick={ctaOnClick}>
                {ctaText}
            </div>
        ) : null}
    </>
);
